// Concept-teksten voor "Wat is er nieuw", per versie.
// Bij elke wijziging zet ik hier onder `_next` een vers voorstel klaar. Zodra er
// een nieuwe versie live gaat, vult de beheer-editor dit automatisch voor —
// management hoeft het alleen te controleren, evt. aan te passen en op Opslaan te
// klikken (om het aan de medewerkers te tonen) of op Annuleren (om het over te slaan).
export const RELEASE_NOTES = {
  // Altijd-klaar voorstel voor de eerstvolgende versie (fallback als er geen
  // versie-specifiek concept is). Werk dit bij elke wijziging bij.
  _next: {
    id: "2026-09-22",
    title: "Urenlijst per bureau in Excel, personeelsnummers en voorraad SE/ST",
    body:
      "Wat is er veranderd:\n" +
      "\n" +
      "- Urenlijst in Excel: per uitzendbureau (en voor HR) kun je de gewerkte uren nu als Excel-bestand downloaden — per medewerker de uren per dag, een totaal per medewerker en een detail met begintijd, eindtijd en pauze. Dagen zonder uren staan er altijd in als Vrij / Ziek / Vakantie.\n" +
      "- Personeelsnummer: vul bij Stamgegevens → Personeel het personeelsnummer in; het staat dan als eerste kolom op de urenlijst, oplopend gesorteerd.\n" +
      "- Pauze: de pauze op de urenlijst toont weer exact 60 minuten (of de handmatig ingevulde pauze); de kwartier-afronding geldt alleen voor de netto uren.\n" +
      "- Weekend: vakantie/ziek op zaterdag of zondag wordt niet meer op uitdraaien getoond (wij werken ma t/m vr).\n" +
      "- Voorraad: de startvoorraad van Vleugels plat/dik gemengd SE/ST en drie andere grondstoffen is eenmalig rechtgezet (verbruik van vóór het inboeken telde onterecht mee). Nieuwe partijen en verbruik lopen gewoon door.\n" +
      "- Foutmeldingen: krijg je onverwacht een blauw scherm, dan wordt de fout automatisch naar beheer gestuurd en herstelt de app zichzelf.\n" +
      "- Halffabricaat boeken: typ het partijnummer in het veld Partij en de juiste partij wordt automatisch gekoppeld. Boeken zonder partij is niet meer mogelijk als er partijen van die grondstof zijn ingeboekt — zo klopt de voorraad per tracecode altijd.\n" +
      "- Versiegeschiedenis terugzetten kan alleen nog door Bedrijfsleiding.\n" +
      "\n" +
      "Groet,\n" +
      "Raymond Clarke",
  },
  "v1.7.0": {
    title: "We zijn officieel online! Inloggen via productiexl.online",
    body:
      "Goed nieuws: ons productie- en salessysteem staat vanaf nu officieel online.\n" +
      "\n" +
      "Je logt voortaan in via productiexl.online met je bekende e-mailadres en wachtwoord. Sla de site op als favoriet of installeer hem op je telefoon (Toevoegen aan beginscherm).\n" +
      "\n" +
      "Wat er verder nieuw is:\n" +
      "- Offertes: kies bij het downloaden zelf welke onderdelen je verbergt (bijv. het totaalbedrag).\n" +
      "- Larissa (assistent): kent nu de wetgeving voor snackproducenten én legt uit hoe je het CRM gebruikt. Klik op de knop rechtsonder of start de 'Rondleiding'.\n" +
      "- Voorraad per tracecode: telt nu correct en boekt af op de tracecode die jij kiest.\n" +
      "- Halffabricaten: twee varianten (bijv. SE/ST + regulier) zet je als 2 regels; de prijs wordt gewogen gemiddeld en de kruiden schalen mee met het totale gewicht.\n" +
      "- Scannen: bij een onbekende grondstofnaam vraagt de app om te koppelen aan de juiste voorraad.\n" +
      "- De mobiele scan is nu ook in het Roemeens en Pools beschikbaar.\n" +
      "\n" +
      "Groet,\n" +
      "Raymond Clarke",
  },
};

// Exacte versie-match eerst; anders het altijd-klare `_next`-voorstel.
export function getDraft(version) {
  return RELEASE_NOTES[version] || RELEASE_NOTES._next || null;
}
